import { render, staticRenderFns } from "./Atendimentos.vue?vue&type=template&id=04029e84"
import script from "./Atendimentos.vue?vue&type=script&lang=js"
export * from "./Atendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports